import { createStore } from 'vuex'
import axios from 'axios'
import {
  isLocal,
  isCancelMagicsnapPro,
  isStageMagicsnapPro,
  isCancelUbodyFit,
  isCancelUbodyKz,
  isCancelUstretchSite,
  isCancelUbodySite,
  isCancelUbodyApp,
  isCancelSelfStretchRu,
  isCancelUpriseBodyRu,
  isCancelUFoodSite,
  isCancelUtarotInfo,
  isCancelSelfstretchKz,
  isCancelSingmywishCom,
  isCancelTretcheasyCom,
  isCancelPhotofiltersPro,
  isCancelTarotinoRu,
  isCancelArtdeepfiltersKz,
  isCancelUbundleRu,
  isCancelUbodyPro,
  isCancelFadaDateCom
} from '@/utils/stand'

// import the auto exporter
import modules from './modules'

const getConfigUrl = () => {
  switch (true) {
    case isCancelMagicsnapPro():
    case isLocal():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.magicsnap.pro'
    case isStageMagicsnapPro():
      return 'https://config.artdeepfilters.com/api/v1/config?key=stage.magicsnap.pro'
    case isCancelUbodyFit():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.ubody.fit'
    case isCancelUbodyKz():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.ubody.kz'
    case isCancelUstretchSite():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.ustretch.site'
    case isCancelUbodySite():
      return 'https://config.pwhelp.ru/api/v1/config?key=cancel.ubody.site'
    case isCancelUbodyApp():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.ubody.app'
    case isCancelSelfStretchRu():
      return 'https://config.pwhelp.ru/api/v1/config?key=cancel.selfstretch.ru'
    case isCancelUpriseBodyRu():
      return 'https://config.pwhelp.ru/api/v1/config?key=cancel.uprisebody.ru'
    case isCancelUtarotInfo():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.utarot.info'
    case isCancelUFoodSite():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.u-food.site'
    case isCancelSelfstretchKz():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.selfstretch.kz'
    case isCancelSingmywishCom():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.singmywish.com'
    case isCancelTretcheasyCom():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.stretchyeasy.com'
    case isCancelPhotofiltersPro():
      return 'https://config.pwhelp.ru/api/v1/config?key=cancel.photofilters.pro'
    case isCancelTarotinoRu():
      return 'https://config.pwhelp.ru/api/v1/config?key=cancel.tarotino.ru'
    case isCancelArtdeepfiltersKz():
      return 'https://config.artdeepfilters.com/api/v1/config?key=cancel.artdeepfilters.kz'
    case isCancelUbundleRu():
      return 'https://config.pwhelp.ru/api/v1/config?key=cancel.ubundle.ru'
    case isCancelUbodyPro():
      return 'https://config.pwhelp.ru/api/v1/config?key=cancel.ubody.pro'
    case isCancelFadaDateCom():
      return 'https://config.pwhelp.ru/api/v1/config?key=cancel.fada-date.com'
  }
}

export const config = axios.create({
  baseURL: getConfigUrl()
})

export const cdp = axios.create({
  baseURL: 'https://cdp.sigmamobi.com/api/'
  // baseURL: 'http://devel.sigmadev.ru:8103/api/'
})

const store = createStore({
  modules
})

export function useStore() {
  return store
}

export default store
